<div #chart [class.currency-selected]="isDefined(selectedCcy)"></div>
